import React, { useEffect, useId, useRef } from 'react';

import { CreditRewardContent } from './CreditRewardContent';

import './CreditRewardModal.css';

interface CreditRewardModalProps {
  open: boolean;
  title: string;
  status: string;
  credits: number | null;
  message: string;
  busy: boolean;
  action: string;
  onAction: () => void;
  onClose: () => void;
  creditDescription?: string;
  secondaryAction?: { label: string; onClick: () => void };
}

const useRewardDialog = (ref: React.RefObject<globalThis.HTMLDialogElement | null>, open: boolean) => {
  useEffect(() => {
    const dialog = ref.current;

    if (!dialog) return undefined;
    if (open) dialog.showModal();
    else if (dialog.open) dialog.close();

    return () => { if (dialog.open) dialog.close(); };
  }, [ref, open]);
};

export const CreditRewardModal: React.FC<CreditRewardModalProps> = ({
  open, title, status, credits, message, busy, action, onAction, onClose,
  creditDescription = 'available to claim', secondaryAction,
}) => {
  const ref = useRef<globalThis.HTMLDialogElement>(null);
  const id = useId();

  useRewardDialog(ref, open);

  return (
    <dialog ref={ref} className="credit-reward-dialog signup-credit-award-overlay" aria-modal="true"
      aria-labelledby={`${id}-title`}
      aria-describedby={`${id}-message`} onCancel={event => { event.preventDefault(); if (!busy) onClose(); }}
      onClick={event => { if (event.target === event.currentTarget && !busy) onClose(); }}>
      <div className="signup-credit-award-modal">
        <CreditRewardContent titleId={`${id}-title`} messageId={`${id}-message`}
          title={title} eyebrow={status} amount={credits} creditDescription={creditDescription}
          message={message} busy={busy} actionLabel={action} closeLabel="Close credit reward"
          onAction={onAction} onClose={onClose} secondaryAction={secondaryAction} />
      </div>
    </dialog>
  );
};
